module.exports = __webpack_public_path__ + "static/media/29EUNOG13.4ceb3454.jpg";